import { useQuery } from "@apollo/client/react";
import type {
  ExternalLookupCompanyResult,
  LookupExternalCompanyFilter,
} from "../queries/getExternalLookupCompany";
import GET_EXTERNAL_LOOKUP_COMPANY from "../queries/getExternalLookupCompany";

export const useExternalLookup = (
  lookupFilters?: LookupExternalCompanyFilter,
  skip?: boolean,
) => {
  const shouldSkip =
    skip || !lookupFilters?.searchTerm || lookupFilters.searchTerm.length < 2;

  const { data, error, loading, previousData, refetch } =
    useQuery<ExternalLookupCompanyResult>(GET_EXTERNAL_LOOKUP_COMPANY, {
      variables: {
        sortDirection: lookupFilters?.sortDirection,
        sortBy: lookupFilters?.sortBy,
        searchTerm: lookupFilters?.searchTerm ?? "",
        identifierType: lookupFilters?.identifierType,
        skip: lookupFilters?.skip ?? 0,
        take: lookupFilters?.take ?? 20,
      },
      skip: shouldSkip,
      notifyOnNetworkStatusChange: true,
    });
  return { lookup: data?.lookup, error, loading, previousData, refetch };
};
